/**
 * Mask sensitive contact values for users without `contacts:all` permission.
 * Used in contact detail views where call-center operators see contact info
 * but must not be able to copy/exfiltrate full email or phone numbers.
 *
 * Rules:
 * - If `canSeeAll` is true, return the value unchanged.
 * - If value is null/undefined/empty, return '-'.
 * - For emails (contains '@'): keep first 2 chars of local part + domain.
 *   Example: "jan.novak@example.cz" → "ja***@example.cz"
 * - For phones / other strings >4 chars: keep last 4 digits.
 *   Example: "+420 777 123 456" → "***3 456"
 * - For shorter values: full mask.
 */
export function maskValue(
  value: string | null | undefined,
  canSeeAll: boolean,
): string {
  if (!value) return '-';
  if (canSeeAll) return value;

  if (value.includes('@')) {
    const [local = '', domain = ''] = value.split('@');
    return `${local.slice(0, 2)}***@${domain}`;
  }

  if (value.length > 4) return `***${value.slice(-4)}`;
  return '***';
}
